<template>
    <v-container fluid class="menu">
        <v-row>
            <v-col name="Logo" cols="8" lg="2" style="padding-top:0!important;padding-bottom:0!important;">
                <router-link to="/">
                    <v-img :src="logo" max-height="120px" min-height="100%" contain height="-webkit-fill-available" position="left top"/>
                </router-link>
            </v-col>
            <v-col name="MenuPrincipal" lg="7" class="hidden-md-and-down" align-self="center">
                <v-btn text rounded :to="$t('Alias.Disenadores')" class="menusBotones">{{$t('Menu.Disenadores')}}</v-btn>
                <v-btn text rounded :to="$t('Alias.Artistas')" class="menusBotones">{{$t('Menu.Artistas')}}</v-btn>
                <v-menu name="Experiencias" offset-y>
                    <template v-slot:activator="{ on }">
                        <v-hover> <!-- v-slot:default="{ hover }" -->
                        <v-btn text rounded v-on="on" class="menusBotones">{{$t('Menu.Experiencias')}}</v-btn>
                        </v-hover>
                    </template>
                    <v-list nav>
                        <v-list-item v-for="i in subExperiencias" :key="i.titulo" :to="$t(i.enlace)" class="submenus">
                        <v-list-item-title>{{ $t(i.titulo) }}</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
                <v-btn text rounded :to="$t('Alias.Magazine')" class="menusBotones">{{$t('Menu.Magazine')}}</v-btn>
                <v-btn text rounded :to="$t('Alias.Empresas')" class="menusBotones">{{$t('Menu.Empresas')}}</v-btn>
                <v-btn v-if="getRol === 'administrador'" text rounded :to="$t('Alias.AdministracionGeneral')" class="menusBotones">{{$t('Menu.Administracion')}}</v-btn>
                <v-btn v-if="getRol === 'artista'" text rounded :to="$t('Alias.ProductosOficina')" class="menusBotones">{{$t('Menu.Oficina')}}</v-btn>
                <v-btn v-if="getRol === 'moderador'" text rounded :to="$t('Alias.Moderacion')" class="menusBotones">{{$t('Menu.Moderacion')}}</v-btn>
            </v-col>
            <v-col name="MenuSecundario" lg="3" class="hidden-md-and-down text-right" align-self="center">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" icon class="hidden-md-and-down" :to="$t('Alias.GeneralPerfil')"><v-icon size="20">far fa-user</v-icon></v-btn>
                  </template>
                  <span>{{$t('Menu.Perfil')}}</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-hover v-slot:default="{ hover }">
                      <v-btn v-on="on" value="es" small text class="px-1 ml-1" style="min-width:0!important;" :style="hover ? 'background:#F8F100;' : ''" @click="setIdioma('es')">ES</v-btn>
                    </v-hover>
                  </template>
                  <span>Español</span>
                </v-tooltip>
                  <span>|</span>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-hover v-slot:default="{ hover }">
                    <v-btn v-on="on" value="en" small text class="px-1" style="min-width:0!important;" :style="hover ? 'background:#F8F100;' : ''" @click="setIdioma('en')">EN</v-btn>
                    </v-hover>
                  </template>
                  <span>English</span>
                </v-tooltip>
                <v-menu name="Moneda" open-on-hover offset-y>
                    <template v-slot:activator="{ on }">
                        <v-btn icon class="hidden-md-and-down" v-on="on"><v-icon size="20">fas fa-dollar-sign</v-icon></v-btn>
                    </template>
                    <v-list nav rounded>
                        <v-list-item v-for="i in getMonedas" :key="i.titulo" @click="setMoneda(i.id)">
                        <v-list-item-avatar size="16">
                            <v-img :src="i.src" style="max-width: 100% !important;"></v-img>
                        </v-list-item-avatar>
                        <v-list-item-title>{{i.titulo}}</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" icon color="grey" :to="$t('Alias.Regalo')" class="hidden-md-and-down">
                      <v-icon size="20">fas fa-gift</v-icon>
                    </v-btn>
                  </template>
                  <span>{{$t('Menu.Regalo')}}</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" icon class="hidden-md-and-down mx-2" :to="$t('Alias.Carrito')">
                    <v-badge color="secondary">
                        <template v-slot:badge>{{ getCarritoCantidad }}</template>
                        <v-icon size="24">fas fa-shopping-bag</v-icon>
                    </v-badge>
                    </v-btn>
                  </template>
                  <span>{{$t('Menu.Carrito')}}</span>
                </v-tooltip>
                <v-tooltip bottom v-if="getLogeado">
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" icon class="hidden-md-and-down ml-3" @click="CerrarSesion"><v-icon size="20">fas fa-sign-out-alt</v-icon></v-btn>
                  </template>
                  <span>{{$t('Menu.CerrarSesion')}}</span>
                </v-tooltip>
            </v-col>
            <v-spacer />
            <v-col name="Drawer" class="hidden-lg-and-up text-right" align-self="center">
                <v-btn text @click="drawer = !drawer"><v-icon>fas fa-bars</v-icon></v-btn>
            </v-col>
            <!-- NAVEGATION DRAWER -->
      <v-navigation-drawer app right v-model="drawer">
        <v-list nav rounded>
          <v-list-item name="Disenadores" :to="$t('Alias.Disenadores')">
            <v-list-item-title class="ml-2">{{ $t('Menu.Disenadores')}}</v-list-item-title>
            <v-list-item-icon>
              <v-icon color="primary">fas fa-screwdriver</v-icon>
            </v-list-item-icon>
          </v-list-item>
          <v-list-item name="Artistas" :to="$t('Alias.Artistas')">
            <v-list-item-title class="ml-2">{{ $t('Menu.Artistas')}}</v-list-item-title>
            <v-list-item-icon>
              <v-icon color="primary">fas fa-palette</v-icon>
            </v-list-item-icon>
          </v-list-item>
          <v-list-group name="Experiencias">
            <v-list-item slot="activator">
              <v-list-item-title>{{$t('Menu.Experiencias')}}</v-list-item-title>
            </v-list-item>
            <v-list-item v-for="i in subExperiencias" :key="i.titulo" :to="$t(i.enlace)">
            <v-list-item-title> {{ $t(i.titulo)}}</v-list-item-title>
            <v-list-item-icon>
              <v-icon color="primary">{{i.icono}}</v-icon>
            </v-list-item-icon>
          </v-list-item>
          </v-list-group>
          <v-list-item name="Magazine" :to="$t('Alias.Magazine')">
            <v-list-item-title class="ml-2">{{ $t('Menu.Magazine')}}</v-list-item-title>
            <v-list-item-icon>
              <v-icon color="primary">far fa-newspaper</v-icon>
            </v-list-item-icon>
          </v-list-item>
          <v-list-item name="Empresas" :to="$t('Alias.Empresas')">
            <v-list-item-title class="ml-2">{{ $t('Menu.Empresas')}}</v-list-item-title>
            <v-list-item-icon>
              <v-icon color="primary">far fa-building</v-icon>
            </v-list-item-icon>
          </v-list-item>
          <v-list-item name="Oficina" v-if="getRol === 'artista'" :to="$t('Alias.ProductosOficina')">
            <v-list-item-title class="ml-2">{{ $t('Menu.Oficina')}}</v-list-item-title>
            <v-list-item-icon>
              <v-icon color="primary">fas fa-chart-line</v-icon>
            </v-list-item-icon>
          </v-list-item>
          <v-list-item name="Administracion" v-if="getRol === 'administrador'" :to="$t('Alias.AdministracionGeneral')">
            <v-list-item-title class="ml-2">{{ $t('Menu.Administracion')}}</v-list-item-title>
            <v-list-item-icon>
              <v-icon color="primary">fas fa-user-shield</v-icon>
            </v-list-item-icon>
          </v-list-item>
          <v-list-item name="Moderacion" v-if="getRol === 'moderador'" :to="$t('Alias.Moderacion')">
            <v-list-item-title class="ml-2">{{ $t('Menu.Moderacion')}}</v-list-item-title>
            <v-list-item-icon>
              <v-icon color="primary">fas fa-user-tie</v-icon>
            </v-list-item-icon>
          </v-list-item>
          <v-list-item name="Perfil" :to="$t('Alias.GeneralPerfil')">
            <v-list-item-title class="ml-2">{{ $t('Menu.Perfil')}}</v-list-item-title>
            <v-list-item-icon>
              <v-icon color="primary">far fa-user</v-icon>
            </v-list-item-icon>
          </v-list-item>
          <v-list-item name="Regalo" :to="$t('Alias.Regalo')">
            <v-list-item-title class="ml-2">{{$t('Menu.Regalo')}}</v-list-item-title>
            <v-list-item-icon>
              <v-icon color="primary">fas fa-gift</v-icon>
            </v-list-item-icon>
          </v-list-item>
          <v-list-item name="Carrito" :to="$t('Alias.Carrito')">
            <v-list-item-title class="ml-2">{{ $t('Menu.Carrito')}}</v-list-item-title>
            <v-list-item-icon class="mr-1">
              <v-badge color="secondary">
                <template v-slot:badge>{{ getCarritoCantidad }}</template>
                <v-icon color="primary" size="24">fas fa-shopping-bag</v-icon>
              </v-badge>
            </v-list-item-icon>
          </v-list-item>
          <v-list-group name="Idioma">
            <v-list-item slot="activator">
              <v-list-item-title>{{ $t('SubMenus.Idioma') }}</v-list-item-title>
            </v-list-item>
            <v-list-item v-for="i in getIdiomas" :key="i.titulo" @click="setIdioma(i.id)">
              <v-list-item-avatar size="16">
              <v-img :src="i.src" style="max-width: 100% !important;"></v-img>
            </v-list-item-avatar>
            <v-list-item-title>{{i.titulo}}</v-list-item-title>
          </v-list-item>
          </v-list-group>
          <v-list-group name="Moneda">
            <v-list-item slot="activator">
              <v-list-item-title>{{ $t('SubMenus.Moneda')}}</v-list-item-title>
            </v-list-item>
            <v-list-item v-for="i in getMonedas" :key="i.titulo" @click="setMoneda(i.id)">
            <v-list-item-avatar size="16">
              <v-img :src="i.src" style="max-width: 100% !important;"></v-img>
            </v-list-item-avatar>
              <v-list-item-title>{{i.titulo}}</v-list-item-title>
            </v-list-item>
          </v-list-group>
          <v-list-item name="CerrarSesion" v-if="getRol !== 'invitado'" @click="CerrarSesion">
            <v-list-item-title class="ml-2">{{ $t('Menu.CerrarSesion') }}</v-list-item-title>
            <v-list-item-icon>
              <v-icon color="primary">fas fa-sign-out-alt</v-icon>
            </v-list-item-icon>
          </v-list-item>
          <v-list-item name="CerrarMenu" @click="drawer = false">
            <v-list-item-title class="ml-2">{{ $t('Menu.CerrarMenu') }}</v-list-item-title>
            <v-list-item-icon>
              <v-icon color="primary">fas fa-caret-left</v-icon>
            </v-list-item-icon>
          </v-list-item>
        </v-list>
      </v-navigation-drawer>
        </v-row>
        <v-btn color="white" fab large style="position:fixed;right:1%;top:90%;z-index:10;border-radius:50%!important" href="https://wa.me/573213025754" target="_blank">
          <v-icon size="42" color="green">fab fa-whatsapp</v-icon>
        </v-btn>
    </v-container>
</template>

<script>
import logo from '@/assets/logo.png'
import { mapGetters, mapActions, mapMutations } from 'vuex'
export default {
  name: 'Navegacion',
  data () {
    return {
      logo,
      drawer: false,
      subExperiencias: [
        {
          id: 'Eventos',
          icono: 'far fa-calendar-alt',
          titulo: 'Menu.Eventos',
          enlace: 'Alias.Eventos'
        },
        {
          id: 'Tours',
          icono: 'fas fa-map-marker-alt',
          titulo: 'Menu.Tours',
          enlace: 'Alias.Tours'
        },
        {
          id: 'Club',
          icono: 'far fa-gem',
          titulo: 'Menu.Club',
          enlace: 'Alias.Club'
        }
      ]
    }
  },
  computed: {
    ...mapGetters(['getIdiomas', 'getMonedas', 'getCarritoCantidad', 'getRol', 'getLogeado', 'getTotal', 'getSubtotal'])
  },
  methods: {
    ...mapMutations(['setIdioma', 'setMoneda', 'limpiarCarrito', 'setTotal']),
    ...mapActions(['cerrarSesion']),
    CerrarSesion () {
      // this.setTotal()
      this.cerrarSesion()
    }
  }
}
</script>

<style>
.menu {
  margin-top: 20px;
  height: 120px;
  margin: 0 10% !important;
  padding: 0 !important;
}
.menusBotones {
  text-transform: capitalize!important;
  font-size: 18px!important;
  font-family: 'Be Vietnam', sans-serif!important;
  font-weight: 400!important;
}
</style>
